import { createSlice } from '@reduxjs/toolkit';

const initialState = {
   data: {}, // { [msgId]: { messageData } }
};

const repliedMessagesSlice = createSlice({
   name: 'repliedMessagesData',
   initialState,
   reducers: {
      setRepliedMessage: (state, action) => {
         const { msgId, data } = action.payload;
         if (msgId && data) {
            state.data[msgId] = data;
         }
      },
      setRepliedMessages: (state, action) => {
         const messages = action.payload;
         if (Array.isArray(messages)) {
            messages.forEach(msg => {
               if (msg.msgId) {
                  state.data[msg.editMessageId] = msg;
               }
            });
         }
      },
      deleteRepliedMessages: (state, action) => {
         const { msgIds } = action.payload;
         msgIds?.forEach(msgId => {
            if (state.data[msgId]) {
               delete state.data[msgId];
            }
         });
      },
      recallRepliedMessages: (state, action) => {
         const { msgIds } = action.payload;
         msgIds?.forEach(msgId => {
            if (state.data[msgId]) {
               state.data[msgId].deleteStatus = 1;
            }
         });
      },
      clearRepliedMessages: state => {
         state.data = {};
      },
   },
});

export const {
   setRepliedMessage,
   setRepliedMessages,
   deleteRepliedMessages,
   recallRepliedMessages,
   clearRepliedMessages,
} = repliedMessagesSlice.actions;
export const { reducer: repliedMessagesReducer } = repliedMessagesSlice;
